/* eslint-disable import/no-unresolved */
import { LoanDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import * as types from "../../Types/loanDetails";

export const setLoanDetails = (payload: LoanDetails) => ({
  type: types.SET_LOAN_DETAILS,
  payload
});

export const saveLoanDetails = (apiData: any, masterData: any, leadId: string) => ({
  type: types.SAVE_LOAN_DETAILS,
  payload: { apiData, masterData, leadId }
});
